import React from 'react'
import { Icon, Text, Wrapper } from './ButtonExternalAuthOption.styles'
import type { ButtonExternalAuthOptionProps } from './types'

const ButtonExternalAuthOption = ({
  icon,
  text,
  onClick
}: ButtonExternalAuthOptionProps) => {
  return (
    <Wrapper onClick={onClick}>
      <Icon src={icon} />
      <Text>{text}</Text>
    </Wrapper>
  )
}

export default ButtonExternalAuthOption
